import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/query';
import moment from 'moment';
import { useHasSubscription, useSubscriptionPlans } from '@bbkAdminUtils/plans';
import {
  useDaysToExpiration,
  useSelectCompanySubscription,
} from '@bbkAdminRedux/rtkq/checkout.slice';
import { selectCompanyInternalName } from '@bbkAdminRedux/app/selectors';

export const usePurchaseFeature = () => {
  const { isEssentialsPlan } = useSubscriptionPlans();
  const expiration = useDaysToExpiration();

  const hasSubscription = useHasSubscription();
  const companyInternalName = useSelector(selectCompanyInternalName);
  const subscription = useSelectCompanySubscription(
    hasSubscription
      ? {
          company: companyInternalName,
        }
      : skipToken
  );

  const alertText = useMemo(() => {
    if (!expiration) return undefined;
    const { isTrial, endDate } = expiration;
    const daysToExpiry = endDate.diff(moment.utc(), 'days');
    if (isTrial) {
      return daysToExpiry < 0
        ? 'Trial expired'
        : `Expires on ${endDate.format('MMM D, YYYY')} UTC`;
    }
    if (isEssentialsPlan) {
      const usage = subscription
        ? ` (${subscription.usage}\\${subscription.price.included_session_limit})`
        : '';
      return `Essentials plan ${usage}`;
    }
    return undefined;
  }, [expiration, isEssentialsPlan, subscription]);

  return useMemo(() => ({ alertText }), [alertText]);
};
